'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { createPolymorphicComponent } from '@s7/base';
import { S7S7Tablet } from '@s7/icons';
import { composeHandlers } from '@s7/react-utils';
import { ActionIcon } from '@s7/ui';
import { useAnalytics } from '../../analytics.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const _HeaderLogo = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { sx, onClick } = props, others = _object_without_properties_loose(props, [
        "sx",
        "onClick"
    ]);
    const headerTopic = useAnalytics('header');
    return /*#__PURE__*/ jsx(ActionIcon, _extends({
        ref: ref,
        size: 44,
        onClick: composeHandlers(onClick, headerTopic.goMain)
    }, others, {
        children: /*#__PURE__*/ jsx(S7S7Tablet, {})
    }));
});
const HeaderLogo = createPolymorphicComponent(_HeaderLogo);

export { HeaderLogo };
//# sourceMappingURL=HeaderLogo.js.map
